var Map = function Map(key) {
	var $ = require('jquery');
	var GoogleMapsLoader = require('google-maps');
	var $map = $('[data-map="true"]');

	GoogleMapsLoader.LIBRARIES = ['geometry', 'places'];
	GoogleMapsLoader.KEY = key;
	GoogleMapsLoader.load(function(google) {

		var bounds = new google.maps.LatLngBounds();
		var isDraggable = $(document).width() > 480 ? true : false;

		var map = new google.maps.Map($map[0], {
			center: new google.maps.LatLng(47.4441, 45),
			zoom: 2,
			draggable: isDraggable,
			scrollwheel: false,
			disableDefaultUI: true,
			styles: [{"featureType":"all","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"administrative","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"landscape","elementType":"all","stylers":[{"color":"#fff"}]},{"featureType":"poi","elementType":"all","stylers":[{"color":"#fff"}]},{"featureType":"road","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"transit","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"water","elementType":"all","stylers":[{"color":"#939597"},{"visibility":"on"}]}]
		});
		var pins = [];

		var closeAllPins = function(){
			pins.forEach(function(object){
				object._info.close(map, object._gmark);
			});
		};

		$.ajax('/members-cache.json', {
			success: function(data) {
				data.forEach(function(mark) {
					var gmark = new google.maps.Marker({
						position: {
							lat: parseFloat(mark.acf.location.lat),
							lng: parseFloat(mark.acf.location.lng)
						},
						map: map,
						url: mark.link,
						icon: 'wp-content/themes/pm-child/images/icon.png'
					});

					bounds.extend(gmark.position);

					var info = new google.maps.InfoWindow({
						content: '<a href="' + mark.link + '">' + mark.title.rendered + '<i class="fa fa-chevron-circle-right white"></i></a>',
						pixelOffset: new google.maps.Size(-95, 68)
					});

					pins.push( {
						_gmark : gmark,
						_info : info
					} );

					gmark.addListener('click', function() {
						closeAllPins(); 
						info.open(map, gmark);
					});

					info.addListener('domready', function() {
						$('.gm-style-iw').prev().remove().end();
					});

				});
				map.fitBounds(bounds);
			}
		});
	});
}

module.exports = Map;